document.addEventListener('DOMContentLoaded', function () {

    const form = document.querySelector('form[action*="/contact"]');

    if (!form) return;
    if (typeof SalesforceInteractions === 'undefined') return;

    function setHiddenField(name, value) {
        let field = form.querySelector(`[name="${name}"]`);

        if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = name;
            form.appendChild(field);
        }

        field.value = value || '';
    }

    form.addEventListener('submit', function () {

        const firstName = form.querySelector('[name="contact[First Name]"]')?.value || '';
        const lastName = form.querySelector('[name="contact[Last Name]"]')?.value || '';
        const email = form.querySelector('[name="contact[email]"]')?.value || '';
        const phone = form.querySelector('[name="contact[Mobile Phone]"]')?.value || '';
        const company = form.querySelector('[name="contact[Company]"]')?.value || '';
        const industryRole = form.querySelector('[name="contact[Industry/ Role]"]')?.value || '';

        // Hidden fields for Salesforce External Form Handler
        setHiddenField('firstname', firstName);
        setHiddenField('yourname', lastName);
        setHiddenField('youremail', email);
        setHiddenField('yourphone', phone);
        setHiddenField('yourcompany', company);
        setHiddenField('yourcountry', '');
        setHiddenField('yourindustry', industryRole);

        SalesforceInteractions.sendEvent({
            interaction: {
                name: 'contact-us-form'
            },
            user: {
                attributes: {
                    eventType: 'identity',
                    firstname: firstName,
                    lastname: lastName,
                    email: email,
                    mobilephone: phone,
                    company: company,
                    industryrole: industryRole,
                    isAnonymous: 0
                }
            }
        });

        SalesforceInteractions.sendEvent({
            user: {
                attributes: {
                    eventType: 'contactPointEmail',
                    email: email
                }
            }
        });

    });

});



// Website Training Session Registration
const trainingForm = document.getElementById('contact_form');

if (trainingForm) {

    trainingForm.id = 'MCLLIWHU73JVB4TBYESTIBYD2444';
    trainingForm.setAttribute('data-uma-forms', 'true');

    function setTrainingHiddenField(name, value) {
        let field = trainingForm.querySelector(`[name="${name}"]`);

        if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = name;
            trainingForm.appendChild(field);
        }

        field.value = value || '';
    }

    trainingForm.addEventListener('submit', function () {

        const firstName = trainingForm.querySelector('[name="contact[First name]"]')?.value || '';
        const lastName = trainingForm.querySelector('[name="contact[Last name]"]')?.value || '';
        const email = trainingForm.querySelector('[name="contact[email]"]')?.value || '';
        const phone = trainingForm.querySelector('[name="contact[Phone]"]')?.value || '';
        const company = trainingForm.querySelector('[name="contact[Company]"]')?.value || '';

        setTrainingHiddenField('firstname', firstName);
        setTrainingHiddenField('yourname', lastName);
        setTrainingHiddenField('company', company);
        setTrainingHiddenField('position', '');
        setTrainingHiddenField('country', '');
        setTrainingHiddenField('youremail', email);
        setTrainingHiddenField('phone', phone);

    });

}


// Website Quote
const quoteForm = document.getElementById('raq-items-form');
const quoteButton = document.getElementById('raq_form_submit');

if (quoteForm && quoteButton) {

    quoteForm.id = 'MCIRI4HPRZYVBUPKXRCT6D42DGWM';
    quoteForm.setAttribute('data-uma-forms', 'true');

    function setQuoteHiddenField(name, value) {
        let field = quoteForm.querySelector(`[name="${name}"]`);

        if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = name;
            quoteForm.appendChild(field);
        }

        field.value = value || '';
    }

    quoteButton.addEventListener('click', function () {

        const firstName = document.getElementById('raq_fname')?.value || '';
        const lastName = document.getElementById('raq_lname')?.value || '';
        const email = document.getElementById('raq_email')?.value || '';
        const phone = document.getElementById('raq_phone')?.value || '';
        const company = document.getElementById('raq_company_name')?.value || '';

        setQuoteHiddenField('billing_first_name', firstName);
        setQuoteHiddenField('billing_last_name', lastName);
        setQuoteHiddenField('billing_email', email);
        setQuoteHiddenField('billing_phone', phone);
        setQuoteHiddenField('billing_company', company);
        setQuoteHiddenField('billing_country', '');

    });

}


// Website Career Form
const careerForm = document.querySelector('form[data-id="156806"]');

if (careerForm) {

    careerForm.id = 'MCBKLM6IXCE5FI5OOBLXPUMOVLKQ';
    careerForm.setAttribute('data-uma-forms', 'true');

    function setCareerHiddenField(name, value) {
        let field = careerForm.querySelector(`[name="${name}"]`);

        if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = name;
            careerForm.appendChild(field);
        }

        field.value = value || '';
    }

    careerForm.addEventListener('submit', function () {

        setCareerHiddenField('firstName', careerForm.querySelector('[name="text-2"]')?.value);
        setCareerHiddenField('lastName', careerForm.querySelector('[name="text-3"]')?.value);
        setCareerHiddenField('youremail', careerForm.querySelector('[name="email"]')?.value);
        setCareerHiddenField('country', careerForm.querySelector('[name="text-4"]')?.value);
        setCareerHiddenField('availability', careerForm.querySelector('[name="select-2"]')?.value);
        setCareerHiddenField('menu73', careerForm.querySelector('[name="select-1"]')?.value);
        setCareerHiddenField('Areaofinterest', careerForm.querySelector('[name="textarea"]')?.value);

    });

}

// Website Newsletter & WhatsApp Updates Form
const newsletterForm = document.querySelector('form[name="customer"], form[action*="/contact#newsletter"]');

if (newsletterForm) {

    newsletterForm.id = 'MCZEQ2GCCRTBHIRFXF3R2BZKOAFY';
    newsletterForm.setAttribute('data-uma-forms', 'true');

    function setNewsletterHiddenField(name, value) {
        let field = newsletterForm.querySelector(`[name="${name}"]`);

        if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = name;
            newsletterForm.appendChild(field);
        }

        field.value = value || '';
    }

    newsletterForm.addEventListener('submit', function () {

        const email = newsletterForm.querySelector('[name="contact[email]"]')?.value || '';

        setNewsletterHiddenField('firstname', '');
        setNewsletterHiddenField('yourname', '');
        setNewsletterHiddenField('youremail', email);
        setNewsletterHiddenField('yourprefix', '');
        setNewsletterHiddenField('yourtel', '');
        setNewsletterHiddenField('yourcompany', '');
        setNewsletterHiddenField('yourcountry', '');
        setNewsletterHiddenField('yourrole', '');

    });

}